import AxiosService from '../AxiosService';

const CreditCardDebitPayment = async (data: object) => {
  const instance = AxiosService.createProductsAxiosInstance();
  const response = await instance.post(`/iopay/card`, data);
  return response.data;
};

const PixDebitPayment = async (data: object) => {
  const instance = AxiosService.createProductsAxiosInstance();
  const response = await instance.post(`/iopay/pix`, data);
  return response.data;
};

export default {
  CreditCardDebitPayment,
  PixDebitPayment,
};
